// Utility per lookup comuni italiani (ISTAT 2020, 7904 comuni)
// Il file comuni.json viene caricato lazy dal public folder

let COMUNI_CACHE = null;
let LOADING_PROMISE = null;

// Normalizza stringhe per matching (lowercase, rimuove accenti/trattini/punti)
export const normalize = (s) => {
  if (!s) return '';
  return s
    .toLowerCase()
    .trim()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // rimuove accenti
    .replace(/['`.,]/g, '')           // rimuove apostrofi/punti
    .replace(/[-_]/g, ' ')            // trattini → spazi
    .replace(/\s+/g, ' ');            // comprime spazi
};

// Carica lazy il JSON dei comuni
export const loadComuni = async () => {
  if (COMUNI_CACHE) return COMUNI_CACHE;
  if (LOADING_PROMISE) return LOADING_PROMISE;

  LOADING_PROMISE = fetch('/comuni.json')
    .then((r) => r.json())
    .then((data) => {
      // Pre-computa chiavi normalizzate
      COMUNI_CACHE = data.map((c) => ({
        ...c,
        _key: normalize(c.n),
      }));
      return COMUNI_CACHE;
    })
    .catch(() => {
      COMUNI_CACHE = [];
      return [];
    });

  return LOADING_PROMISE;
};

// Lookup esatto: nome città → { regione, provincia, cap }
export const lookupCity = async (cityName) => {
  if (!cityName) return null;
  const comuni = await loadComuni();
  const key = normalize(cityName);

  // 1. Match esatto
  let found = comuni.find((c) => c._key === key);
  if (found) return { nome: found.n, regione: found.r, provincia: found.p, cap: found.c[0] };

  // 2. Match esatto ignorando trattini e parole tipo "di/del/della"
  const keyClean = key.replace(/\b(di|del|della|delle|dei|in|a|al|alla|d|sul|sulla|su)\b/g, '').replace(/\s+/g, ' ').trim();
  found = comuni.find((c) => {
    const k = c._key.replace(/\b(di|del|della|delle|dei|in|a|al|alla|d|sul|sulla|su)\b/g, '').replace(/\s+/g, ' ').trim();
    return k === keyClean;
  });
  if (found) return { nome: found.n, regione: found.r, provincia: found.p, cap: found.c[0] };

  return null;
};

// Ricerca fuzzy per autocomplete: ritorna i primi N risultati
export const searchCities = async (query, limit = 10) => {
  if (!query || query.trim().length < 2) return [];
  const comuni = await loadComuni();
  const key = normalize(query);

  // Prima: match su prefisso (più rilevanti)
  const prefix = comuni.filter((c) => c._key.startsWith(key));
  // Poi: match contains (meno rilevanti)
  const contains = comuni.filter((c) => !c._key.startsWith(key) && c._key.includes(key));

  return [...prefix, ...contains].slice(0, limit).map((c) => ({
    nome: c.n,
    regione: c.r,
    provincia: c.p,
    cap: c.c[0],
    label: `${c.n} (${c.p}) – ${c.r}`,
  }));
};
